module.exports = __webpack_public_path__ + "img/loading-report.ea87cd36.gif";